import { LocalStorageService } from 's2s-app-service';

export const LS_VERSION_KEYS = {
  V0: 'V0',
};

export const LS_SECTION_KEYS = {
  ALERTS: 'alert_collection',
  CALL_HISTORY: 'call_history',
  SETTINGS: 'settings',
  CONTACTS: 'contacts',
};

export const LS_VERSIONS = {
  [LS_SECTION_KEYS.ALERTS]: LS_VERSION_KEYS.V0,
  [LS_SECTION_KEYS.CALL_HISTORY]: LS_VERSION_KEYS.V0,
  [LS_SECTION_KEYS.SETTINGS]: LS_VERSION_KEYS.V0,
  [LS_SECTION_KEYS.CONTACTS]: LS_VERSION_KEYS.V0,
};


/** Method that stores versioned data for specific section.
 *
 * @param sectionKey { string } - section alias.
 * @param dataToStore{ any }   - data to store.
 * @returns { boolean } - true if no errors, false if errors.
 */
export const storeLocalData = (sectionKey, dataToStore) => {
  if (Object.values(LS_SECTION_KEYS).some(key => key === sectionKey)) {
    const storageKey = `${sectionKey}.${LS_VERSIONS[sectionKey]}`;
    try {
      LocalStorageService.setData(storageKey, dataToStore);

      return true;
    } catch(e) {
      console.error(e && e.toString());

      return false;
    }
  } else {
    return false;
  }
};

/** Method that stores versioned data for specific section.
 *
 * @param sectionKey { string } - section alias.
 * @param defaultValue{ any }   - value to return if storage does not have required data.
 * @returns { boolean } - true if no errors, false if errors.
 */
export const retrieveLocalData = (sectionKey, defaultValue) => {
  if (Object.values(LS_SECTION_KEYS).some(key => key === sectionKey)) {
    const storageKey = `${sectionKey}.${LS_VERSIONS[sectionKey]}`;

    try {
      const storedData = LocalStorageService.getData(storageKey);

      return storedData.data || defaultValue;
    } catch(e) {
      console.error(e && e.toString());

      return defaultValue;
    }
  } else {
    return defaultValue;
  }
};
